module.exports = __webpack_public_path__ + "img/DE02596.b2a0af6e.png";